// src/utils/GoogleMap.jsx (replace the current file)
import React from 'react';

const MapDisplay = ({
  height = '200px',
  width = '100%',
  latitude = 59.3813398,
  longitude = 17.949853,
  borderRadius = '12px',
  zoom = 14,
}) => {
  // Google Maps embed – no API key needed
  const src = `https://www.google.com/maps?q=${latitude},${longitude}&z=${zoom}&output=embed`;
  const link = `https://www.google.com/maps?q=${latitude},${longitude}&z=${zoom}`;

  return (
    <div
      style={{
        height: height || '200px',     // fallback if you pass ""
        width: width || '100%',
        borderRadius,
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <iframe
        title="map"
        src={src}
        width="100%"
        height="100%"
        style={{ border: 0 }}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
      {/* Optional: a tiny "Open in Maps" button */}
      <a
        href={link}
        target="_blank"
        rel="noreferrer"
        style={{
          position: 'absolute',
          right: 8,
          bottom: 8,
          background: 'white',
          padding: '4px 8px',
          borderRadius: 8,
          fontSize: 12,
          textDecoration: 'none',
        }}
      >
        Open in Maps
      </a>
    </div>
  );
};

export default MapDisplay;
